var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"resource-card",style:({ borderLeft: ("4px solid " + (_vm.resource.statusColor)) }),on:{"click":function($event){return _vm.$emit('selectResource', _vm.resource)}}},[_c('h1',[_vm._v(_vm._s(_vm.resource.name))]),_c('span',{style:({
            color: String(_vm.resource.statusColor),
            backgroundColor: ((_vm.resource.statusColor) + "20"),
            minWidth: this.resource.statusName.length < 20 && 'fit-content !important'
        })},[_vm._v(_vm._s(_vm.resource.statusName))])])}
var staticRenderFns = []

export { render, staticRenderFns }